import { useIntl } from '@jetshop/intl'
import React from 'react'
import InputWithLabel from '../../../Forms/InputWithLabelVB'
import { FormFieldRow } from '../SignUpForm'
import PrivateCustomerFields from './PrivateCustomerFields'

export default function CompanyCustomerFields({ requiredHint }) {
   const t = useIntl()

   const lblOrgNr = t('Org number')
   const lblCompany = t('Company name')
   const lblStreet = t('Address')
   const lblPostal = t('Postal code')
   const lblCity = t('City')

   return (
      <>
         <FormFieldRow
            fieldId="organizationNumber"
            labelText={lblOrgNr}
            requiredHint={requiredHint}
         >
            <InputWithLabel
               hideLabel
               smallField
               name="organizationNumber"
               type="text"
               label={lblOrgNr}
               placeholder={lblOrgNr}
            />
         </FormFieldRow>
         <FormFieldRow
            fieldId="companyName"
            labelText={lblCompany}
            requiredHint={requiredHint}
         >
            <InputWithLabel
               hideLabel
               smallField
               name="companyName"
               type="text"
               label={lblCompany}
               placeholder={lblCompany}
            />
         </FormFieldRow>
         <FormFieldRow
            fieldId="streetName"
            labelText={lblStreet}
            requiredHint={requiredHint}
         >
            <InputWithLabel
               hideLabel
               smallField
               name="streetName"
               type="text"
               label={lblStreet}
               placeholder={lblStreet}
            />
         </FormFieldRow>
         <FormFieldRow
            fieldId="postalCode"
            labelText={lblPostal}
            requiredHint={requiredHint}
         >
            <InputWithLabel
               hideLabel
               smallField
               name="postalCode"
               type="text"
               label={lblPostal}
               placeholder={lblPostal}
            />
         </FormFieldRow>
         <FormFieldRow
            fieldId="city"
            labelText={lblCity}
            requiredHint={requiredHint}
         >
            <InputWithLabel
               hideLabel
               smallField
               name="city"
               type="text"
               label={lblCity}
               placeholder={lblCity}
            />
         </FormFieldRow>

         <PrivateCustomerFields requiredHint={requiredHint} />
      </>
   )
}
